import { render, staticRenderFns } from "./CustomCalendarV2.vue?vue&type=template&id=0becfd14&scoped=true"
import script from "./CustomCalendarV2.vue?vue&type=script&lang=js"
export * from "./CustomCalendarV2.vue?vue&type=script&lang=js"
import style0 from "./CustomCalendarV2.vue?vue&type=style&index=0&id=0becfd14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0becfd14",
  null
  
)

export default component.exports